import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { sanitizeHtml } from 'modules/contracts/lib/sanitizeHtml'

interface Props {
  jobDescription?: string
}

const RoleDescription = ({ jobDescription }: Props) => {
  const sanitizedDescription = sanitizeHtml(jobDescription)

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 6 }} gap="s8">
      <Text size="200" weight="normal" color="grey800">
        {i18n.t('contract_versions.job_position.job_description')}
      </Text>
      {jobDescription && (
        <Text size="300" weight="medium" color="grey1000">
          {sanitizedDescription}
        </Text>
      )}
      {!jobDescription && (
        <Text size="300" weight="medium" color="grey600">
          {i18n.t('contract_versions.job_position.not_informed')}
        </Text>
      )}
    </Box>
  )
}

export default RoleDescription
